document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.testimonial-carousel');
  const slides = document.querySelectorAll('.testimonial');
  const dotsContainer = document.querySelector('.carousel-navigation');
  let currentIndex = 0;
  let slidesToShow = 3; // Mostrar 3 reseñas a la vez por defecto
  let totalSlides = slides.length; // Total de reseñas
  let startX = 0;
  let endX = 0;
  let isMouseDown = false;

  // Función para actualizar el número de testimonios visibles dependiendo del tamaño de la pantalla
  function updateSlidesToShow() {
    if (window.innerWidth <= 768) {
      slidesToShow = 1;  // En móviles, mostrar 1 reseña a la vez
    } else {
      slidesToShow = 3;  // En pantallas grandes, mostrar 3 reseñas a la vez
    }
  }

  // Crear puntos de navegación (dots) dinámicamente
  function createDots() {
    dotsContainer.innerHTML = ''; // Limpiar los dots existentes
    const totalDots = Math.ceil(totalSlides / slidesToShow); // Calcular el número de grupos de testimonios
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      if (i === 0) {
        dot.classList.add('active');
      }
      dotsContainer.appendChild(dot);
    }
  }

  // Mostrar u ocultar testimonios según el índice actual
  function updateVisibility() {
    slides.forEach((slide, index) => {
      if (index >= currentIndex && index < currentIndex + slidesToShow) {
        slide.style.display = 'block'; // Mostrar la reseña
      } else {
        slide.style.display = 'none'; // Ocultar la reseña
      }
    });
  }

  // Actualizar el carrusel, los puntos y el deslizamiento
  function updateCarousel() {
    updateSlidesToShow();

    // Asegurarse de que nunca se quede una sola reseña en la última página.
    if (currentIndex + slidesToShow > totalSlides) {
      currentIndex = totalSlides - slidesToShow;
      if (currentIndex < 0) {
        currentIndex = 0;
      }
    }

    updateVisibility();

    // Actualizar los puntos (dots)
    const dots = dotsContainer.querySelectorAll('.dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === Math.floor(currentIndex / slidesToShow));
    });
  }

  // Deslizar automáticamente cada 5 segundos
  let autoSlide = setInterval(() => {
    currentIndex += slidesToShow;
    if (currentIndex >= totalSlides) {
      currentIndex = 0;  // Reiniciar el índice si llega al final
    }
    updateCarousel();
  }, 5000);

  // Manejar el clic en los puntos (dots)
  dotsContainer.addEventListener('click', (event) => {
    if (event.target.classList.contains('dot')) {
      clearInterval(autoSlide);  // Detener el deslizado automático
      const dots = Array.from(dotsContainer.children);
      currentIndex = dots.indexOf(event.target) * slidesToShow;
      updateCarousel();
      autoSlide = setInterval(() => { // Reanudar el deslizado automático
        currentIndex += slidesToShow;
        if (currentIndex >= totalSlides) {
          currentIndex = 0;
        }
        updateCarousel();
      }, 5000);
    }
  });

  // Función para manejar el inicio del swipe con touch (móviles)
  function handleTouchStart(event) {
    startX = event.touches[0].clientX; // Capturar la posición inicial del toque
  }

  // Función para manejar el final del swipe con touch
  function handleTouchEnd(event) {
    endX = event.changedTouches[0].clientX; // Capturar la posición final del toque
    handleSwipeGesture(); // Verificar si fue un deslizamiento
  }

  // Función para manejar el inicio del swipe con mouse (ordenadores)
  function handleMouseDown(event) {
    isMouseDown = true;
    startX = event.clientX; // Capturar la posición inicial del clic
  }

  // Función para manejar el final del swipe con mouse
  function handleMouseUp(event) {
    if (!isMouseDown) return;
    isMouseDown = false;
    endX = event.clientX; // Capturar la posición final del clic
    handleSwipeGesture(); // Verificar si fue un deslizamiento
  }

  // Detectar el gesto de swipe
  function handleSwipeGesture() {
    if (startX - endX > 50) {
      // Swipe hacia la izquierda (siguiente)
      clearInterval(autoSlide);
      currentIndex += slidesToShow;
      if (currentIndex >= totalSlides) {
        currentIndex = 0;
      }
      updateCarousel();
      autoSlide = setInterval(() => {
        currentIndex += slidesToShow;
        if (currentIndex >= totalSlides) {
          currentIndex = 0;
        }
        updateCarousel();
      }, 5000);
    } else if (endX - startX > 50) {
      // Swipe hacia la derecha (anterior)
      clearInterval(autoSlide);
      currentIndex -= slidesToShow;
      if (currentIndex < 0) {
        currentIndex = totalSlides - slidesToShow;
      }
      updateCarousel();
      autoSlide = setInterval(() => {
        currentIndex += slidesToShow;
        if (currentIndex >= totalSlides) {
          currentIndex = 0;
        }
        updateCarousel();
      }, 5000);
    }
  }

  // Añadir eventos para detectar el swipe en móviles y en ordenadores
  carousel.addEventListener('touchstart', handleTouchStart);
  carousel.addEventListener('touchend', handleTouchEnd);
  carousel.addEventListener('mousedown', handleMouseDown);
  carousel.addEventListener('mouseup', handleMouseUp);

  // Inicializar el carrusel y los dots
  updateSlidesToShow();
  createDots();
  updateVisibility();
  updateCarousel();

  // Ajustar el carrusel cuando se cambia el tamaño de la ventana (responsive)
  window.addEventListener('resize', () => {
    updateSlidesToShow();
    createDots(); // Recrear los dots si cambia el número de testimonios visibles
    updateVisibility();
    updateCarousel();
  });
});
